import { useCallback } from 'react'
import type { RecentActivity } from '@renderer/overlay/Sidepanel/types'
import { useViewActions, type ViewOpenTarget } from '@renderer/overlay/Sidepanel/view-atoms'
import { MEETING_VIEW_ID } from '@renderer/overlay/Sidepanel/components/meeting/meeting-view-id'

/** Which View a history row opens, shared by Home's section and the History view. */
export function useOpenActivity(sourceLabel: string) {
  const { openView } = useViewActions()
  return useCallback(
    (item: RecentActivity, open: ViewOpenTarget) => {
      const options = { sourceLabel, ...open }
      if (item.type === 'chat') {
        openView('chat', { chatId: item.id, title: item.title }, options)
      } else if (item.type === 'audio-note') {
        openView(MEETING_VIEW_ID, { mode: 'note', audioNoteId: item.id, title: item.title }, options)
      } else if (item.type === 'completed-action') {
        openView('action', { actionId: item.id, title: item.title, braintrustLink: item.braintrustLink }, options)
      }
    },
    [openView, sourceLabel],
  )
}
